import { shapeDate } from '@avangard/utils/data';

import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { StudentOnlineApplicationFillResponsible } from '@modules/types/graphql';

export type Entity = Partial<StudentOnlineApplicationFillResponsible> | null;

@DecribeEntity('StudentOnlineApplicationResponsibleEntity')
class StudentOnlineApplicationResponsibleEntity extends BaseEntity {
    fullName: string;
    birthdate: Date | null;
    passportSerial: string;
    passportNumber: string;
    passportIssued: string;
    passportAddress: string;
    address: string;
    phone: string;
    email: string;

    constructor(entity: Entity) {
        super(entity);

        this.fullName = entity?.fullName ?? '';
        this.birthdate = shapeDate(entity?.birthdate);
        this.passportSerial = entity?.passportSerial ?? '';
        this.passportNumber = entity?.passportNumber ?? '';
        this.passportIssued = entity?.passportIssued ?? '';
        this.passportAddress = entity?.passportAddress ?? '';
        this.address = entity?.address ?? '';
        this.phone = entity?.phone ?? '';
        this.email = entity?.email ?? '';
    }

    issetAnyField() {
        return (
            this.fullName !== '' ||
            this.birthdate !== null ||
            this.passportSerial !== '' ||
            this.passportNumber !== '' ||
            this.passportIssued !== '' ||
            this.address !== '' ||
            this.phone !== '' ||
            this.email !== ''
        );
    }
}

export { StudentOnlineApplicationResponsibleEntity };
